export default __webpack_public_path__ + "static/techguru-example10-dcd16e1fe7bc4cf72d08f2c2035181f9.png";